export interface Country {
  code: string;
  name: string;
}

export const baseCountries: Country[] = [
  { code: "UG", name: "אוגנדה" },
  { code: "UZ", name: "אוזבקיסטן" },
  { code: "AT", name: "אוסטריה" },
  { code: "AU", name: "אוסטרליה" },
  { code: "UA", name: "אוקראינה" },
  { code: "UY", name: "אורוגוואי" },
  { code: "AZ", name: "אזרבייג'ן" },
  { code: "CX", name: "אי כריסטמס" },
  { code: "AE", name: "איחוד האמירויות הערביות" },
  { code: "IT", name: "איטליה" },
  { code: "BS", name: "איי בהאמה" },
  { code: "GS", name: "איי ג'ורג'יה הדרומית ואיי סנדוויץ' הדרומיים" },
  { code: "UM", name: "איי האוקיינוס השקט (ארה״ב)" },
  { code: "VI", name: "איי הבתולה (ארה״ב)" },
  { code: "VG", name: "איי הבתולה (בריטניה)" },
  { code: "HM", name: "איי הרד ומקדונלד" },
  { code: "TC", name: "איי טרקס וקייקוס" },
  { code: "MP", name: "איי מריאנה הצפוניים" },
  { code: "MH", name: "איי מרשל" },
  { code: "SB", name: "איי סולומון" },
  { code: "FO", name: "איי פארו" },
  { code: "FK", name: "איי פוקלנד" },
  { code: "FJ", name: "איי פיג'י" },
  { code: "KM", name: "איי קומורו" },
  { code: "CK", name: "איי קוק" },
  { code: "CC", name: "איי קוקוס" },
  { code: "KY", name: "איי קיימן" },
  { code: "ID", name: "אינדונזיה" },
  { code: "IS", name: "איסלנד" },
  { code: "IE", name: "אירלנד" },
  { code: "IR", name: "אירן" },
  { code: "SV", name: "אל-סלבדור" },
  { code: "AL", name: "אלבניה" },
  { code: "DZ", name: "אלג'יר" },
  { code: "AX", name: "אלנד" },
  { code: "AO", name: "אנגולה" },
  { code: "AI", name: "אנגילה" },
  { code: "AD", name: "אנדורה" },
  { code: "AQ", name: "אנטארקטיקה" },
  { code: "AG", name: "אנטיגואה וברבודה" },
  { code: "EE", name: "אסטוניה" },
  { code: "AF", name: "אפגניסטן" },
  { code: "EC", name: "אקוודור" },
  { code: "AR", name: "ארגנטינה" },
  { code: "US", name: 'ארה"ב' },
  { code: "AW", name: "ארובה" },
  { code: "ER", name: "אריתריאה" },
  { code: "AM", name: "ארמניה" },
  { code: "ET", name: "אתיופיה" },
  { code: "BT", name: "בהוטן" },
  { code: "BV", name: "בובה" },
  { code: "BW", name: "בוטסואנה" },
  { code: "BG", name: "בולגריה" },
  { code: "BO", name: "בוליביה" },
  { code: "BA", name: "בוסניה והרצגובינה" },
  { code: "BI", name: "בורונדי" },
  { code: "BF", name: "בורקינה פאסו" },
  { code: "BH", name: "בחריין" },
  { code: "BY", name: "בלארוס" },
  { code: "BE", name: "בלגיה" },
  { code: "BZ", name: "בליז" },
  { code: "BD", name: "בנגלדש" },
  { code: "BJ", name: "בנין" },
  { code: "BB", name: "ברבדוס" },
  { code: "BN", name: "ברוניי" },
  { code: "BR", name: "ברזיל" },
  { code: "GB", name: "בריטניה" },
  { code: "BM", name: "ברמודה" },
  { code: "DJ", name: "ג'יבוטי" },
  { code: "JM", name: "ג'מייקה" },
  { code: "JE", name: "ג'רזי" },
  { code: "GA", name: "גאבון" },
  { code: "GE", name: "גאורגיה" },
  { code: "GH", name: "גאנה" },
  { code: "GT", name: "גואטמלה" },
  { code: "GU", name: "גואם" },
  { code: "GP", name: "גוואדלופ" },
  { code: "GY", name: "גיאנה" },
  { code: "GI", name: "גיברלטר" },
  { code: "GN", name: "גינאה" },
  { code: "GW", name: "גינאה ביסאו" },
  { code: "GQ", name: "גינאה המשוונית" },
  { code: "GF", name: "גינאה הצרפתית" },
  { code: "GM", name: "גמביה" },
  { code: "GL", name: "גרינלנד" },
  { code: "DE", name: "גרמניה" },
  { code: "GD", name: "גרנדה" },
  { code: "GG", name: "גרנזי" },
  { code: "DM", name: "דומיניקה" },
  { code: "DK", name: "דנמרק" },
  { code: "ZA", name: "דרום אפריקה" },
  { code: "SS", name: "דרום סודן" },
  { code: "KR", name: "דרום קוריאה" },
  { code: "IM", name: "האי מאן" },
  { code: "NF", name: "האי נורפוק" },
  { code: "HT", name: "האיטי" },
  { code: "MV", name: "האיים המלדיביים" },
  { code: "BQ", name: "האנטילים ההולנדיים" },
  { code: "IN", name: "הודו" },
  { code: "NL", name: "הולנד" },
  { code: "HK", name: "הונג קונג" },
  { code: "HU", name: "הונגריה" },
  { code: "HN", name: "הונדורס" },
  { code: "IO", name: "הטריטוריה הבריטית באוקיינוס ההודי" },
  { code: "TF", name: "הטריטוריות הדרומיות של צרפת" },
  { code: "PH", name: "הפיליפינים" },
  { code: "DO", name: "הרפובליקה הדומיניקנית" },
  { code: "CD", name: "הרפובליקה הדמוקרטית של קונגו" },
  { code: "CF", name: "הרפובליקה המרכז אפריקאית" },
  { code: "PS", name: "הרשות הפלסטינית" },
  { code: "WF", name: "ואליס ופוטונה" },
  { code: "VN", name: "וייטנאם" },
  { code: "VU", name: "ונואטו" },
  { code: "VE", name: "ונצואלה" },
  { code: "VA", name: "ותיקן" },
  { code: "ZW", name: "זימבבואה" },
  { code: "ZM", name: "זמביה" },
  { code: "CI", name: "חוף השנהב" },
  { code: "TJ", name: "טג'יקיסטן" },
  { code: "TV", name: "טובאלו" },
  { code: "TG", name: "טוגו" },
  { code: "TO", name: "טונגה" },
  { code: "TN", name: "טוניסיה" },
  { code: "TK", name: "טוקלאו" },
  { code: "TR", name: "טורקיה" },
  { code: "TM", name: "טורקמינסטן" },
  { code: "TW", name: "טיוואן" },
  { code: "TZ", name: "טנזניה" },
  { code: "TT", name: "טרינידד וטובאגו" },
  { code: "GR", name: "יוון" },
  { code: "JP", name: "יפן" },
  { code: "JO", name: "ירדן" },
  { code: "IL", name: "ישראל" },
  { code: "KW", name: "כווית" },
  { code: "CV", name: "כף ורדה" },
  { code: "LA", name: "לאוס" },
  { code: "LB", name: "לבנון" },
  { code: "LY", name: "לוב" },
  { code: "LU", name: "לוקסמבורג" },
  { code: "LV", name: "לטביה" },
  { code: "LR", name: "ליבריה" },
  { code: "LT", name: "ליטא" },
  { code: "LI", name: "ליכטנשטיין" },
  { code: "LS", name: "לסוטו" },
  { code: "MR", name: "מאוריטניה" },
  { code: "MU", name: "מאוריציוס" },
  { code: "ML", name: "מאלי" },
  { code: "MG", name: "מדגסקר" },
  { code: "MZ", name: "מוזמביק" },
  { code: "MD", name: "מולדובה" },
  { code: "MN", name: "מונגוליה" },
  { code: "ME", name: "מונטנגרו" },
  { code: "MS", name: "מונטסראט" },
  { code: "MC", name: "מונקו" },
  { code: "TL", name: "מזרח טימור" },
  { code: "MM", name: "מיאנמר" },
  { code: "YT", name: "מיוט" },
  { code: "FM", name: "מיקרונזיה" },
  { code: "MW", name: "מלאווי" },
  { code: "MY", name: "מלזיה" },
  { code: "MT", name: "מלטה" },
  { code: "EG", name: "מצרים" },
  { code: "MO", name: "מקאו" },
  { code: "MK", name: "מקדוניה" },
  { code: "MX", name: "מקסיקו" },
  { code: "MA", name: "מרוקו" },
  { code: "MQ", name: "מרטיניק" },
  { code: "NR", name: "נאורו" },
  { code: "NO", name: "נורווגיה" },
  { code: "NG", name: "ניגריה" },
  { code: "NZ", name: "ניו זילנד" },
  { code: "NU", name: "ניואה" },
  { code: "NE", name: "ניז'ר" },
  { code: "NI", name: "ניקרגואה" },
  { code: "NA", name: "נמיביה" },
  { code: "NP", name: "נפאל" },
  { code: "ST", name: "סאו טומה ופרינסיפה" },
  { code: "SJ", name: "סבאלברד ויאן מאיין" },
  { code: "EH", name: "סהרה המערבית" },
  { code: "SD", name: "סודן" },
  { code: "SZ", name: "סוואזילנד" },
  { code: "SO", name: "סומליה" },
  { code: "SY", name: "סוריה" },
  { code: "SR", name: "סורינאם" },
  { code: "SL", name: "סיירה לאון" },
  { code: "SC", name: "סיישל" },
  { code: "CN", name: "סין" },
  { code: "SG", name: "סינגפור" },
  { code: "SI", name: "סלובניה" },
  { code: "SK", name: "סלובקיה" },
  { code: "WS", name: "סמואה" },
  { code: "AS", name: "סמואה האמריקנית" },
  { code: "BL", name: "סן ברתלמי" },
  { code: "MF", name: "סן מרטן (צרפת)" },
  { code: "SM", name: "סן מרינו" },
  { code: "PM", name: "סן פייר ומיקלון" },
  { code: "SN", name: "סנגל" },
  { code: "SH", name: "סנט הלנה" },
  { code: "VC", name: "סנט וינסנט והגרנדינים" },
  { code: "LC", name: "סנט לוסיה" },
  { code: "SX", name: "סנט מארטן (הולנד)" },
  { code: "KN", name: "סנט קיטס ונוויס" },
  { code: "SA", name: "סעודיה" },
  { code: "ES", name: "ספרד" },
  { code: "RS", name: "סרביה" },
  { code: "LK", name: "סרי לנקה" },
  { code: "OM", name: "עומאן" },
  { code: "IQ", name: "עירק" },
  { code: "PW", name: "פאלאו" },
  { code: "PL", name: "פולין" },
  { code: "PF", name: "פולינזיה הצרפתית" },
  { code: "PR", name: "פורטו ריקו" },
  { code: "PT", name: "פורטוגל" },
  { code: "PN", name: "פיטקרן" },
  { code: "FI", name: "פינלנד" },
  { code: "PA", name: "פנמה" },
  { code: "PG", name: "פפואה גינאה החדשה" },
  { code: "PK", name: "פקיסטן" },
  { code: "PY", name: "פרגוואי" },
  { code: "PE", name: "פרו" },
  { code: "TD", name: "צ'אד" },
  { code: "CL", name: "צ'ילה" },
  { code: "CZ", name: "צ'כיה" },
  { code: "KP", name: "צפון קוריאה" },
  { code: "FR", name: "צרפת" },
  { code: "CU", name: "קובה" },
  { code: "CO", name: "קולומביה" },
  { code: "CG", name: "קונגו" },
  { code: "XK", name: "קוסובו" },
  { code: "CR", name: "קוסטה ריקה" },
  { code: "CW", name: "קוראסאו" },
  { code: "KZ", name: "קזחסטן" },
  { code: "QA", name: "קטאר" },
  { code: "KG", name: "קירגיסטן" },
  { code: "KI", name: "קיריבטי" },
  { code: "NC", name: "קלדוניה החדשה" },
  { code: "KH", name: "קמבודיה" },
  { code: "CM", name: "קמרון" },
  { code: "CA", name: "קנדה" },
  { code: "KE", name: "קניה" },
  { code: "CY", name: "קפריסין" },
  { code: "HR", name: "קרואטיה" },
  { code: "RE", name: "ראוניון" },
  { code: "RW", name: "רואנדה" },
  { code: "RO", name: "רומניה" },
  { code: "RU", name: "רוסיה" },
  { code: "SE", name: "שוודיה" },
  { code: "CH", name: "שוויץ" },
  { code: "TH", name: "תאילנד" },
  { code: "YE", name: "תימן" },
];

export const israelCountry: Country = { code: "IL", name: "ישראל" };
